export default __webpack_public_path__ + "static/media/12.20d40774.jpg";